import styles from "@/components/login-footer.module.css";
import { globals } from "@/globals";
import { t } from "i18next";
import { JSX } from "react";

function LoginFooter(): JSX.Element {
	if (globals.isDesktopApp) {
		return <></>;
	}
	return (
		<footer className={styles["footer"]}>
			&copy; {new Date().getFullYear()}{" "}
			<a
				className={styles["link"]}
				href={globals.home}
				target="_blank"
				rel="noreferrer"
			>
				{t("fuzhouRetieheSoftwareCoLtd")}
			</a>
			<span className="text-divider"></span>
			<a
				className={styles["link"]}
				href="https://docs.retiehe.com/tos.html"
				target="_blank"
				rel="noreferrer"
			>
				{t("termsOfService")}
			</a>
			<span className="text-divider"></span>
			<a
				className={styles["link"]}
				href="https://docs.retiehe.com/privacy.html"
				target="_blank"
				rel="noreferrer"
			>
				{t("privacyPolicy")}
			</a>
			<span className="text-divider"></span>
			<a
				className={styles["link"]}
				href="https://support.retiehe.com/"
				target="_blank"
				rel="noreferrer"
			>
				{t("helpAndFeedback")}
			</a>
		</footer>
	);
}

export default LoginFooter;
